"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerShootSubmissionStrategySchema = exports.ShootSubmissionStrategySchema = exports.S3ShootSubmissionStrategySchema = void 0;
const joi_1 = __importDefault(require("joi"));
exports.S3ShootSubmissionStrategySchema = joi_1.default.object({
    type: joi_1.default.string().allow('s3').required(),
    roleArn: joi_1.default.string().description('iam role from a customer').required(),
    bucketName: joi_1.default.string().description('a destination s3 bucket name').required(),
    prefix: joi_1.default.string().description('a custom prefix for s3 objects').optional(),
    externalId: joi_1.default.string().description('additional security string to assume a role').optional()
})
    .description('AWS IAM Role to use multipart upload')
    .meta({ className: 'S3ShootSubmissionStrategy' });
exports.ShootSubmissionStrategySchema = joi_1.default.alternatives(exports.S3ShootSubmissionStrategySchema)
    .description('Includes details how to upload photos')
    .meta({ className: 'ShootSubmissionStrategy' });
exports.CustomerShootSubmissionStrategySchema = joi_1.default.object({
    organizationUuid: joi_1.default.string().uuid().required(),
    strategy: exports.ShootSubmissionStrategySchema.required()
}).meta({ className: 'CustomerShootSubmissionStrategy' });
//# sourceMappingURL=CustomerShootSubmissionStrategySchema.js.map